import { render, staticRenderFns } from "./pagesLayout.vue?vue&type=template&id=23e5ad8a"
import script from "./pagesLayout.vue?vue&type=script&lang=js"
export * from "./pagesLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23e5ad8a')) {
      api.createRecord('23e5ad8a', component.options)
    } else {
      api.reload('23e5ad8a', component.options)
    }
    module.hot.accept("./pagesLayout.vue?vue&type=template&id=23e5ad8a", function () {
      api.rerender('23e5ad8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/Wrappers/pagesLayout.vue"
export default component.exports